var forgotPhoneController = {
    forgotModal: $('#forgotModal'),
    forgotModalCode: $('#forgotModalPhoneCode'),
    forgotModalFailed: $('#forgotModalPhoneFailed'),
    elForm: $('#forgotPhoneForm'),
    itiForgotPhone: null,
    phone: '',
    countryCode: '',
    init: function(itiForgotPhone)
    {
        forgotPhoneController.itiForgotPhone = itiForgotPhone;
        forgotPhoneController.clearForm();

        forgotPhoneController.elForm.on('keyup keypress', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();

                return false;
            }
        });

        forgotPhoneController.forgotModalCode.find('.js-send-again').click(function() {
            forgotPhoneController.submitForm();

            return false;
        });

        forgotPhoneController.elForm.find('button').click(function() {
            forgotPhoneController.submitForm();

            return false;
        });
    },
    submitForm: function()
    {
        forgotPhoneController.phone = forgotPhoneController.itiForgotPhone.getNumber();
        forgotPhoneController.phone = forgotPhoneController.phone.replace(/\D/g, "");
        forgotPhoneController.countryCode = forgotPhoneController.itiForgotPhone.getSelectedCountryData().iso2.toUpperCase();

        if (!forgotPhoneController.validateForm()) {
            forgotPhoneController.showError();
            return false;
        }

        forgotPhoneController.elForm.find('.js-input-phone-number').val(forgotPhoneController.phone);
        forgotPhoneController.elForm.find('.js-input-phone-country-code').val(forgotPhoneController.countryCode);

        $.post(
            forgotPhoneController.elForm.attr('action'),
            forgotPhoneController.elForm.serialize(),
            function(data) {
                if (data.success) {
                    forgotPhoneController.forgotModalCode.modal('show');
                    forgotPhoneController.forgotModalCode.find('.tip-text span').text(forgotPhoneController.phone);
                    forgotPhoneController.forgotModalCode.find('.js-input-phone-number').val(forgotPhoneController.phone);
                    forgotPhoneController.forgotModalCode.find('.js-input-phone-country-code').val(forgotPhoneController.countryCode);
                    forgotPhoneController.forgotModal.modal('hide');
                    authBaseController.startCountdown(
                        forgotEmailController.forgotModalCode.find('.js-countdown'),
                        forgotEmailController.forgotModalCode.find('.js-send-again')
                    );
                } else {
                    if(!data.isUserExists) {
                        forgotPhoneController.forgotModalFailed.find('.text-top').text(data.message);
                        forgotPhoneController.forgotModalFailed.modal('show');
                        forgotPhoneController.forgotModal.modal('hide');
                    } else {
                        forgotPhoneController.forgotModal.find('.error-text').text(data.message);
                        forgotPhoneController.showError();
                    }
                }
            }, 'json');
    },
    validateForm: function()
    {
        forgotPhoneController.clearForm();
        return forgotPhoneController.itiForgotPhone.isValidNumber();
    },
    clearForm: function()
    {
        forgotPhoneController.elForm.find('.form-group').removeClass('has-error');
        forgotPhoneController.elForm.find('.error-text').hide();
    },
    showError: function()
    {
        forgotPhoneController.elForm.find('.form-group').addClass('has-error');
        forgotPhoneController.elForm.find('.error-text').show();
    }
};

$(function(){
    var forgotPhoneInput = document.getElementById("forgotPhoneIti");
    var itiForgotPhone = window.intlTelInput(forgotPhoneInput, {
        initialCountry: "auto",
        separateDialCode: true,
        geoIpLookup: function (callback) {
            $.get('https://ipinfo.io', function () {
            }, "jsonp").always(function (resp) {
                var countryCode = (resp && resp.country) ? resp.country : "";
                callback(countryCode);
            });
        },
        utilsScript: "/js/plugins/intl-tel-input-17.0.0/build/js/utils.js" // just for formatting/placeholders etc
    });

    forgotPhoneController.init(itiForgotPhone);
});